import { useEffect } from 'react';

export function ServiceWorkerUpdate() {
  useEffect(() => {
    // Écouter le changement de contrôleur (nouvelle version activée)
    let refreshing = false;
    
    const onControllerChange = () => {
      if (!refreshing) {
        refreshing = true;
        console.log('🔄 Nouveau Service Worker actif, rechargement...');
        window.location.reload();
      }
    };

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', onControllerChange);
    }

    return () => {
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('controllerchange', onControllerChange);
      }
    };
  }, []);

  return null; // Ce composant ne rend rien
}